export default __webpack_public_path__ + "static/media/bike-7.497a9543.svg";